import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "middleware/axiosInstance";
import { Row, Col } from "antd";
import { Button, Form, Input } from "antd";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Loading from "layouts/Loading/Loading";

const { TextArea } = Input;

const AddAndEditAboutUs = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [aboutUsInfo, setAboutUsInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getAboutUsInfo();
  }, []);

  useEffect(() => {
    if (aboutUsInfo) {
      form.setFieldsValue(aboutUsInfo);
      setIsLoading(false);
    }
  }, [aboutUsInfo, form]);

  const getAboutUsInfo = () => {
    Axios.get("/about-us")
      .then((res) => {
        // API returns single object (or empty object if no data)
        const data = res.data || {};
        setAboutUsInfo(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const aboutUsEditHandler = async (aboutUs) => {
    Axios.put("/about-us", aboutUs)
      .then((res) => {
        OpenNotificationWithIcon("ویرایش موفق", "با موفقیت ویرایش شد");
        navigate("/dashboard");
      })
      .catch((err) => console.log(err));

  };

  if (isLoading) {
    return (
      <div className="customized-container">
        <div className="customized-wrapper">
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          ویرایش درباره ما
        </h5>
        <Form
          layout="vertical"
          initialValues={aboutUsInfo}
          form={form}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          onFinish={aboutUsEditHandler}
        >
          <Row gutter={8}>
            {/* Title Fields */}
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان فارسی"
                name="title_fa"
                rules={[
                  {
                    required: true,
                    message: "عنوان فارسی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="عنوان فارسی" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان انگلیسی"
                name="title_en"
                rules={[
                  {
                    required: true,
                    message: "عنوان انگلیسی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="English Title" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان عربی"
                name="title_ar"
                rules={[
                  {
                    required: true,
                    message: "عنوان عربی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="العنوان العربي" />
              </Form.Item>
            </Col>

            {/* Brand Message Fields */}
            <Col xs={24}>
              <Form.Item
                label="پیام برند فارسی"
                name="brand_message_fa"
                rules={[
                  {
                    required: true,
                    message: "پیام برند فارسی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="پیام برند فارسی"
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="پیام برند انگلیسی"
                name="brand_message_en"
                rules={[
                  {
                    required: true,
                    message: "پیام برند انگلیسی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="English Brand Message"
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="پیام برند عربی"
                name="brand_message_ar"
                rules={[
                  {
                    required: true,
                    message: "پیام برند عربی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="رسالة العلامة التجارية العربية"
                />
              </Form.Item>
            </Col>

            {/* Description Fields */}
            <Col xs={24}>
              <Form.Item
                label="توضیحات فارسی"
                name="description_fa"
                rules={[
                  {
                    required: true,
                    message: "توضیحات فارسی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="توضیحات فارسی"
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="توضیحات انگلیسی"
                name="description_en"
                rules={[
                  {
                    required: true,
                    message: "توضیحات انگلیسی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="English Description"
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="توضیحات عربی"
                name="description_ar"
                rules={[
                  {
                    required: true,
                    message: "توضیحات عربی الزامی می باشد",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={1000}
                  placeholder="الوصف العربي"
                />
              </Form.Item>
            </Col>

            {/* Branch Title Fields */}
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان شعبه فارسی"
                name="branch_title_fa"
                rules={[
                  {
                    required: true,
                    message: "عنوان شعبه فارسی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="عنوان شعبه فارسی" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان شعبه انگلیسی"
                name="branch_title_en"
                rules={[
                  {
                    required: true,
                    message: "عنوان شعبه انگلیسی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="English Branch Title" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="عنوان شعبه عربی"
                name="branch_title_ar"
                rules={[
                  {
                    required: true,
                    message: "عنوان شعبه عربی الزامی می باشد",
                  },
                ]}
              >
                <Input placeholder="عنوان الفرع العربي" />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Button htmlType="submit" type="primary">
                ثبت تغییرات
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default AddAndEditAboutUs;

